module.exports = __webpack_public_path__ + "img/lista-de-quehaceres.677a530e.png";